import React, { useState } from 'react';
import styled from 'styled-components'
import { Draggable } from "react-beautiful-dnd";
import { useDispatch } from "react-redux";

import { Button, Icon, IconButton } from '../common';
import { Box } from 'vqp-common'
import { ProductsTable } from './'
import { createOrEditCategory } from '../../redux/actions/products'
import { ProductModal } from './ProductModal';

const Card = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  margin-bottom: 30px;
`

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: ${props => props.theme.colors.lightGrey}
`

const Header = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
  width: 100%;
`

const RemoveCategoryWrapper = styled.div`
  margin-left: auto;
` 

const NewProductButton = styled(Button)`
  margin-left: auto;
`

const TitleInput = styled.input.attrs(props => ({
  type: 'text',
  readonly: props.editable
}))`
  border: none;
  font-size: 16px;
  font-weight: 700;
  margin-left: 10px;
  color: ${props => props.theme.colors.textPrimary}

  ${props => props.editable && `
    font-style: italic;
    border-bottom: 1px solid ${props.theme.colors.lightGrey};
  `}
` 

const TableWrapper = styled.div`
  width: 100%;
`

export const Category = ({index, id, name, products, isNew, handleProductDrag, onDeleteCategory, onDeleteProduct, onChangeProductStatus, refetchCategories, storeId}) => {
  const [isDragEnabled, setDragEnabled] = useState(true)
  const [currentName, setCurrentName] = useState(name)
  const [selectedProduct, setSelectedProduct] = useState()
  const [productModalOpen, setProductModalOpen] = useState(false)
  const dispatch = useDispatch()

  const disabledDrag = () => setDragEnabled(false)
  const enableDrag = () => setDragEnabled(true)

  const handleChangeName = (e) => {
    const { value } = e.target
    setCurrentName(value)
  }

  const handleBlurName = async () => {
    return dispatch(createOrEditCategory({category: id, name: currentName, storeId}))
  }

  const confirmDelete = () => {
    if (window.confirm("Tem certeza que deseja deletar esta categoria?")) {
      onDeleteCategory()
    }
  }

  const handleEditProduct = (productId) => {
    setSelectedProduct(productId)
    setProductModalOpen(true)
  }

  const handleDeleteProduct = (productId) => {
    if (window.confirm("Tem certeza que deseja deletar este produto?")) {
      onDeleteProduct(productId, storeId)
    }
  }

  const handleAddNewProduct = () => {
    setSelectedProduct(undefined)
    setProductModalOpen(true)
  }

  const handleCloseProductModal = (edited) => {
    if (edited) {
      refetchCategories()
    }
    setProductModalOpen(false)
  }

  const renderCard = (props) => (
    <Card
      {...props}
    >
      <Header>
        <Icon name="drag" /> 
        <TitleInput editable={true} value={currentName} onChange={handleChangeName} onBlur={handleBlurName} placeholder={'Nome da nova categoria'} />
        <RemoveCategoryWrapper>
          <IconButton icon="delete" onClick={confirmDelete} title={`Excluir`} />
        </RemoveCategoryWrapper>
      </Header>
      <Divider />
      <TableWrapper
        onMouseOver={disabledDrag}
        onMouseOut={enableDrag}
      >
        <ProductsTable 
          category={id} 
          products={products} 
          onDrag={handleProductDrag} 
          onEdit={handleEditProduct} 
          onDelete={handleDeleteProduct}
          onChangeStatus={onChangeProductStatus}
        />
      </TableWrapper>
      <NewProductButton className="primary" onClick={handleAddNewProduct}>
        <Icon name="plus" /> Novo produto
      </NewProductButton>
      <ProductModal 
        category={id} 
        isOpen={productModalOpen} 
        productId={selectedProduct} 
        onClose={handleCloseProductModal} 
        onUpdate={refetchCategories}
        storeId={storeId}
      />
    </Card>
  )

  if (isNew) return renderCard()
  else return (
      <Draggable key={`item${index}`} draggableId={`item${name}`} index={index} isDragDisabled={isNew || !isDragEnabled}>
        {(provided, snapshot) => (
          renderCard({
            ref: provided.innerRef,
            ...provided.draggableProps,
            ...provided.dragHandleProps
          })
        )}
      </Draggable>
  )
}
